export enum CASES {
  GEN_INFORMATION = 'RCI_GeneralInformation',
  HIRING = 'RCI_Contracting',
  CONTRACTUAL_MODIF = 'RCI_ContractModifications',
  DOCUMENTS = 'RCI_Documents',
  CLAIMS = 'RCI_Complaints',
  CUSTOMER_AREA = 'RCI_ClientArea',
  CANCELLATIONS = 'RCI_Cancellations',
  EMAIL = 'RCI_Email',
}

export type CaseType =
  | CASES.GEN_INFORMATION
  | CASES.HIRING
  | CASES.CONTRACTUAL_MODIF
  | CASES.DOCUMENTS
  | CASES.CLAIMS
  | CASES.CUSTOMER_AREA
  | CASES.CANCELLATIONS
  | CASES.EMAIL;
